import React, {useEffect, useState} from 'react';
import {PLACEHOLDER_IMAGE} from '../../Constants';

interface IImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src?: string;
}

/**
 * An image that shows the shared "No image" placeholder when there is no source or the source fails
 * to load, so every card strip (bundles, configurations, saved searches) shows the same empty state
 * instead of a blank box or a broken-image glyph.
 */
const ImageWithFallback: React.FC<IImageWithFallbackProps> = ({src, alt, ...rest}) => {
    const wanted = src && src.trim() !== '' ? src : PLACEHOLDER_IMAGE;
    const [current, setCurrent] = useState(wanted);
    useEffect(() => { setCurrent(wanted); }, [wanted]);
    return <img src={current} alt={alt} onError={() => { if (current !== PLACEHOLDER_IMAGE) setCurrent(PLACEHOLDER_IMAGE); }} {...rest} />;
};

export default ImageWithFallback;
